import api from "./axios";

export async function getUsers(filters = {}) {
  const { name, email, role, pageNo = 1, pageSize = 10 } = filters;

  const params = {};

  if (name && name.trim().length > 0) params.name = name.trim();
  if (email && email.trim().length > 0) params.email = email.trim();
  if (role && role.trim().length > 0) params.role = role.trim();

  params.pageNo = pageNo;
  params.pageSize = pageSize;

  const res = await api.get("/users", { params });
  return res.data;
}

export async function getUserById(id) {
  const res = await api.get(`/users/${id}`);
  return res.data;
}

export async function createUser(payload) {
  const res = await api.post("/users", payload);
  return res.data;
}

export async function updateUser(id, payload) {
  const res = await api.put(`/users/${id}`, payload);
  return res.data;
}

export async function deleteUser(id) {
  const res = await api.delete(`/users/${id}`);
  return res.data;
}
